/*=========================================================================================
  File Name: module-agreement-state.js
  Description: LicenseAgreement Module State
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	SystemInfo: [],
	TermOfUseResult: {}
};
